import { Subject } from "rxjs";

var edits$ = new Subject(null);

function getEdits () {
    return edits$;
}

export default getEdits;